import ReviewDetailComponent from './ReviewDetail';
import type { ReviewDetailProps } from './ReviewDetail';

export type { ReviewDetailProps };
export default ReviewDetailComponent; 